import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Container, Stack, Tabs } from '@mantine/core';
import PageTitle from '@/components/common/PageTitle';
import { IconKey, IconShieldLock, IconUser } from '@tabler/icons-react';
import { ROUTES } from '@/routes/paths';
import { useIsAgent, useIsCarrier } from '@/hooks/useRoles';
import tabClasses from '@/components/common/scrollTabs.module.css';

/** i18n-ключ лейбла слота `api`: у перевозчика это «Интеграция» (его сервер), у прочих — «API-доступ». */
export function apiTabLabelKey(isCarrier: boolean): string {
  return isCarrier ? 'app.profile.tabs.integration' : 'app.profile.tabs.api';
}

// «Личный кабинет»: заголовок + под-вкладки (Профиль / Безопасность / API-доступ|Интеграция) + контент
// (Outlet). Вкладки — обёртка над вложенными маршрутами (deep-linkable).
export default function ProfileLayout() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  // Слот api-access не нужен членам агентской организации (партнёрский API — для продавцов/покупателей).
  const isAgent = useIsAgent();
  const isCarrier = useIsCarrier();

  const active = location.pathname.endsWith('/security')
    ? 'security'
    : location.pathname.endsWith('/api-access')
      ? 'api'
      : 'profile';

  function handleChange(value: string | null): void {
    if (value === 'security') {
      navigate(ROUTES.APP_PROFILE_SECURITY);
    } else if (value === 'api') {
      navigate(ROUTES.APP_PROFILE_API);
    } else {
      navigate(ROUTES.APP_PROFILE);
    }
  }

  return (
    <Container size="md" py="xl">
      <Stack gap="lg">
        <PageTitle>{t('app.account.profile')}</PageTitle>

        <Tabs value={active} onChange={handleChange}>
          <Tabs.List className={tabClasses.list}>
            <Tabs.Tab value="profile" leftSection={<IconUser size={16} />}>
              {t('app.profile.tabs.profile')}
            </Tabs.Tab>
            <Tabs.Tab value="security" leftSection={<IconShieldLock size={16} />}>
              {t('app.profile.tabs.security')}
            </Tabs.Tab>
            {!isAgent ? (
              <Tabs.Tab value="api" leftSection={<IconKey size={16} />}>
                {t(apiTabLabelKey(isCarrier))}
              </Tabs.Tab>
            ) : null}
          </Tabs.List>
        </Tabs>

        <Outlet />
      </Stack>
    </Container>
  );
}
